import React from 'react';
import swal from 'sweetalert';

import clientData from '../../inc/clientData';
import config from '../../inc/config';
import { useNavigate } from 'react-router-dom';

class PermissionModule extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,

            consentCall: 0,
            consentEmail: 0,
            consentSms: 0,

            preferences: {}
        };
    }

    componentDidMount() {
        this.getPreferences();
        window.scrollTo(0, 0);
        console.log("Permissions: componentDidMount()");
    }

    componentWillUnmount() {
        console.log("Permissions: componentWillUnmount()");
    }

    getPreferences() {
        const requestOptions = {
            method: 'GET',
            headers: { 'Authorization': 'Bearer ' + clientData.sessionHash }
        };

        fetch(config.restApi + 'memberPreferences/tr', requestOptions)
            .then(response => response.json())
            .then(responseData => responseData.status === 200 ? this.setState({ isLoading: false, consentCall: responseData.memberPreferencesInfo.consentCall, consentEmail: responseData.memberPreferencesInfo.consentEmail, consentSms: responseData.memberPreferencesInfo.consentSms, preferences: responseData.memberPreferencesInfo }) : swal({ dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: responseData.message, buttons: 'Tamam' }).then(() => this.props.navigate('/')), () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Yeniden Dene' }).then(() => this.getPreferences()));
    }

    saveValidateOnClick(consentCall, consentSms, consentEmail) {
        const requestOptions = {
            method: 'PUT',
            headers: { 'Authorization': 'Bearer ' + clientData.sessionHash, 'Content-Type': 'application/json' },
            body: JSON.stringify({ consentCall: consentCall, consentSms: consentSms, consentEmail: consentEmail })
        };

        fetch(config.restApi + 'memberPreferencesConsents/tr', requestOptions)
            .then(response => response.json())
            .then(responseData => {
                switch (responseData.status) {
                    case 200:
                        swal({
                            dangerMode: true,
                            icon: 'success',
                            title: 'Tamamlandı',
                            text: 'İzinler başarıyla güncellendi.',
                            buttons: 'Tamam'
                        }).then(() => this.getPreferences())
                        break;
                    default:
                        swal({
                            dangerMode: true,
                            icon: 'warning',
                            title: 'Hay Aksi',
                            text: responseData.message,
                            buttons: 'Tamam'
                        });
                        break;
                }
            }, () => swal({ dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam' }));
    }

    render() {console.log(this.state.consentCall, this.state.consentEmail, this.state.consentSms);
        return this.state.isLoading ?
            <div className="ibox-content sk-loading position-static">
                <div className="sk-spinner sk-spinner-fading-circle">
                    <div className="sk-circle1 sk-circle"></div>
                    <div className="sk-circle2 sk-circle"></div>
                    <div className="sk-circle3 sk-circle"></div>
                    <div className="sk-circle4 sk-circle"></div>
                    <div className="sk-circle5 sk-circle"></div>
                    <div className="sk-circle6 sk-circle"></div>
                    <div className="sk-circle7 sk-circle"></div>
                    <div className="sk-circle8 sk-circle"></div>
                    <div className="sk-circle9 sk-circle"></div>
                    <div className="sk-circle10 sk-circle"></div>
                    <div className="sk-circle11 sk-circle"></div>
                    <div className="sk-circle12 sk-circle"></div>
                </div>
            </div>
            :
            <div className="mt-2">
                <div className="row">
                    <div className="col d-flex justify-content-between">
                        <h3 className="text-darkblue">İzinlerim</h3>
                    </div>
                </div>
                <div className="hr-line-dashed mt-0"></div>
                <div className="row">
                    <div className="col my-2">
                        <div className="table-responsive-lg">
                            <table className="table table-bordered text-center">
                                <thead>
                                    <tr className="text-darkblue">
                                        <th>İzin</th>
                                        <th>Telefon</th>
                                        <th>E-posta</th>
                                        <th>SMS</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="align-middle">Bana özel indirimler, teklifler ve tanıtımlar hakkında bilgilendirilmek istiyorum.</td>
                                        <td className="align-middle"><input checked={this.state.consentCall === 1} onChange={() => this.setState({ consentCall: this.state.consentCall === 1 ? 0 : 1 })} type="checkbox" /></td>
                                        <td className="align-middle"><input checked={this.state.consentEmail === 1} onChange={() => this.setState({ consentEmail: this.state.consentEmail === 1 ? 0 : 1 })} type="checkbox" /></td>
                                        <td className="align-middle"><input checked={this.state.consentSms === 1} onChange={() => this.setState({ consentSms: this.state.consentSms === 1 ? 0 : 1 })} type="checkbox" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="row d-flex justify-content-end pr-3 mt-3">
                            <button className="btn bg-darkblue text-white font-bold" onClick={() => this.saveValidateOnClick(this.state.consentCall, this.state.consentSms, this.state.consentEmail)}>Kaydet</button>
                        </div>
                    </div>
                </div>
            </div>
    }
}

export default function Permissions() {
    return (
        <PermissionModule navigate={useNavigate()} />
    )
}